import React from "react";
import Logo from '../../../assets/Logo-02.png';
import Logo40th from '../../../assets/Logo 40th 1.png';
import Bunga from '../../../assets/Bunga.png';
import moment from "moment";
import Barcode from 'react-barcode';
import 'moment/locale/id';
moment.locale('id');

export class ComponentToPrint extends React.PureComponent {
  render() {
    const numberFormat = (value) =>
      new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);

    console.log("ini printan", this.props.item)


    var birthdateTimeStamp = new Date(this.props.item.TANGGAL_LAHIR);
    var cur = new Date();
    var diff = cur - birthdateTimeStamp;
    var currentAge = Math.floor(diff / 31557600000);

    let _pembayaranKonsultasi = 0;
    let _pembayaranBio = 0;
    let _diskon = 0;

    if (this.props.item.PEMBAYARAN_KONSULTASI == 2) {
      let _step1 = this.props.item.HARGA_KONSULTASI - ((this.props.item.PEMBAYARAN_DISKON / 100) * this.props.item.HARGA_KONSULTASI);
      _pembayaranKonsultasi = "Rp." + numberFormat(_step1 - ((25 / 100) * _step1)).replace("Rp", "");
      let _step2 = this.props.item.HARGA_KONSULTASI - ((this.props.item.PEMBAYARAN_DISKON / 100) * this.props.item.HARGA_KONSULTASI);
      _pembayaranBio = "Rp." + numberFormat((25 / 100) * _step2).replace("Rp", "");
      _diskon = ((this.props.item.PEMBAYARAN_DISKON / 100) * this.props.item.HARGA_KONSULTASI);
    }


    return (
      <div className='hide-print'>
        <div
          className="container-fluid"
          style={{
            // maxWidth: "1240px",
            // maxHeight: "874px",
            // backgroundImage: 'url(' + { Bunga } + ')',
            // backgroundPosition: 'center',
            // backgroundRepeat: 'no-repeat',
            // backgroundSize: 'cover',

          }}
        >
          <div id="ui-view" data-select2-id="ui-view">
            <div>
              <div className="card">
                {/* <div className="card-header">Invoice
                <strong>#BBB-10010110101938</strong>
                </div> */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-6" style={{}}>
                      <table style={{}}>
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src={Logo}
                                width="320"
                                alt="Logo"
                                style={{
                                  // padding: 20,
                                  display: "block",
                                }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "20px",
                                  textAlign: 'center'
                                }}
                              >contact@biomedika.co.id - www.biomedika.co.id</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>


                    </div>
                    <div className="col-6" style={{ }}>
                      <div style={{
                        float: "right",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                      }}>

                        <table style={{
                          float: "right",
                        }}>
                          <tbody>

                            <tr>
                              <td>
                                <p
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    textAlign: 'center',
                                  }}
                                >
                                  FRM/Lab/0001
                                </p>
                              </td>
                            </tr>

                          </tbody>
                        </table>


                      </div>
                    </div>

                  </div>

                  <div className="row" style={{ marginLeft: '10px', marginBottom: '0px' }}>
                    <div className="col-12" style={{ marginBottom: '0px' }}>
                      <strong
                        style={{
                          fontSize: 42,
                          fontFamily: "var(--font-family-gotham-black-regular)",
                          // color: 'rgb(15, 71, 62)'
                        }}
                      >
                        RINCIAN BIAYA
                      </strong>
                      <p style={{ fontSize: 22, fontStyle: 'italic', marginTop: '0px', }}>PAYMENT DETAILS</p>
                    </div>
                  </div>

                  <hr style={{ border: "0.5px solid #707070", marginTop: '0px' }} />
                  <form
                    style={{
                      padding: "0px 20px 0px 20px",
                      fontFamily: "Montserrat",
                      // marginTop: "24px",
                    }}
                  >
                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          No. Kuitansi
                        </label>
                        <p>Receipt Number</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >

                          :{" "}{this.props.item.NO_BUKTI_LAYANAN}
                        </label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Nama Pasien
                        </label>
                        <p>Patient Name</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.NAMA_PASIEN}
                        </label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          No. Registrasi
                        </label>
                        <p>Registration Number</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.NOREG}
                        </label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          No. MR
                        </label>
                        <p>Medical Record Number</p>
                      </div>
                      <div className="col-8">


                        <table>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 10 }}>
                              <p>:</p>
                            </td>
                            <td>
                              <label
                                style={{
                                  fontSize: 24,
                                  fontWeight: "500",
                                }}
                              >
                                <Barcode height='60' value={this.props.item.NOMR} />
                              </label>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Tanggal Layanan
                        </label>
                        <p>Service Date</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{moment(moment.utc(this.props.item.TGL_LAYANAN)).local().format("DD MMMM YYYY")}
                        </label>
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          No. Telp
                        </label>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.NO_TELP}
                        </label>
                      </div>
                    </div> */}

                    {/* <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Jenis Kelamin
                        </label>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.JENIS_KELAMIN}
                        </label>
                      </div>
                    </div> */}

                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Nama Dokter
                        </label>
                        <p>Doctor Name</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.NAMA_DOKTER}
                        </label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Umur / Jenis Kelamin
                        </label>
                        <p>Age / Sex</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{currentAge + " Tahun / " + this.props.item.JENIS_KELAMIN}
                        </label>
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          TTL
                        </label>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.TEMPAT_LAHIR != "" ? this.props.item.TEMPAT_LAHIR + ", " + moment(this.props.item.TANGGAL_LAHIR).format("DD-MM-YYYY") : moment(this.props.item.TANGGAL_LAHIR).format("DD-MM-YYYY")}
                        </label>
                      </div>
                    </div> */}

                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Alamat
                        </label>
                        <p>Address</p>
                      </div>
                      <div className="col-8">
                        <table>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 10 }}>
                              <p>:</p>
                            </td>
                            <td>
                              <label
                                style={{
                                  fontSize: 24,
                                  fontWeight: "500",
                                }}
                              >
                                {this.props.item.alamatPasien}
                              </label>
                            </td>
                          </tr>

                        </table>


                      </div>
                    </div>


                    <div className="row">
                      <div
                        style={{
                          position: "absolute",
                          right: "36px",
                          top: "278px",
                        }}
                      >
                        {/* <QRCode
                          id="qr-gen"
                          value={qrValue}
                          size={160}
                          level={"H"}
                          //   includeMargin={true}
                          fgColor="#22485e"
                          imageSettings={{
                            src: logo_,
                            width: 20,
                            height: 20,
                            excavate: true,
                          }}
                        /> */}
                      </div>

                      {/* <div
                        style={{
                          position: "absolute",
                          right: "28px",
                          top: "460px",
                        }}
                      >
                        <Barcode format='CODE128' value={qrValue} width='2px' height='44' displayValue="false" />
                      </div> */}
                    </div>
                  </form>
                  {/* 
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "12px",
                      fontFamily: "Montserrat",
                      marginLeft: "10px",
                      marginTop: "20px",
                      fontSize: 28
                    }}
                  >
                    PERINCIAN
                  </p> */}


                  <hr style={{ border: "0.5px solid #707070" }} />

                  <form
                    style={{
                      padding: "0px 20px 0px 20px",
                      fontFamily: "Montserrat",
                      // marginTop: "24px",
                    }}
                  >

                    <div className="row">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                            textDecoration: 'underline',
                            textUnderlineOffset: '4px'
                          }}
                        >
                          RINCIAN BIAYA :
                        </label>
                        <p>Payment Details:</p>
                      </div>
                      <div className="col-8">
                      </div>
                    </div>


                    <div className="row">
                      <div className="col-8">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                            marginLeft: 60
                          }}
                        >
                          Konsultasi {this.props.item.NAMA_KONSULTASI ? this.props.item.NAMA_KONSULTASI : ""}
                        </label>
                      </div>
                      <div className="col-4">
                        <table>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 100 }} colSpan={2} align="right">
                              <p>Rp.</p>
                            </td>
                            <td style={{ width: 200 }} colSpan={2} align="right">
                              <label
                                style={{
                                  fontSize: 24,
                                  fontWeight: "500",
                                  // textDecoration: 'underline',
                                  // textUnderlineOffset: '8px'
                                }}
                              >
                                {/* {this.props.item.PEMBAYARAN_KONSULTASI == 1 ? numberFormat(0).replace("Rp", "") : numberFormat(this.props.item.TOTAL_HARGA - ((25 / 100) * this.props.item.TOTAL_HARGA)).replace("Rp", "")} */}
                                {this.props.item.PEMBAYARAN_KONSULTASI == 1 || this.props.item.PEMBAYARAN_KONSULTASI == 3 ? "FREE" : null}
                                {this.props.item.PEMBAYARAN_KONSULTASI == 0 ? numberFormat(this.props.item.TOTAL_HARGA).replace("Rp", "") : null}
                                {this.props.item.PEMBAYARAN_KONSULTASI == 2 ? numberFormat(this.props.item.HARGA_KONSULTASI).replace("Rp", "") : null}
                              </label>
                              {/* <p style={{ marginBottom: 0 }}>
                                {this.props.item.PEMBAYARAN_KONSULTASI == 2 ? "(Diskon " + this.props.item.PEMBAYARAN_DISKON + "%)" : null}
                              </p> */}
                            </td>
                          </tr>

                        </table>

                      </div>
                    </div>

                    {/* <div className="row" style={{ display: this.props.item.PEMBAYARAN_KONSULTASI == 0 ? 'none' : null }}>
                      <div className="col-8">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                            marginLeft: 60
                          }}
                        >
                          Biaya Admin
                        </label>
                      </div>
                      <div className="col-4">
                        <table>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 100 }} colSpan={2} align="right">
                              <p>Rp.</p>
                            </td>
                            <td style={{ width: 200 }} colSpan={2} align="right">
                              <label
                                style={{
                                  fontSize: 24,
                                  fontWeight: "500",
                                  // textDecoration: 'underline',
                                  // textUnderlineOffset: '8px'
                                }}
                              >
                                {this.props.item.PEMBAYARAN_KONSULTASI == 1 ? numberFormat(this.props.item.TOTAL_HARGA).replace("Rp", "") : null}
                                {this.props.item.PEMBAYARAN_KONSULTASI == 0 ? numberFormat(((25 / 100) * this.props.item.TOTAL_HARGA)).replace("Rp", "") : null}
                                {this.props.item.PEMBAYARAN_KONSULTASI == 2 ? numberFormat(((25 / 100) * this.props.item.HARGA_KONSULTASI)).replace("Rp", "") : null}
                                {this.props.item.PEMBAYARAN_KONSULTASI == 3 ? "FREE" : null}
                              </label>
                            </td>
                          </tr>


                        </table>

                        <hr style={{ border: "0.5px solid #707070", margin: 4 }} />


                      </div>
                    </div> */}

                    <div className="row" style={{ display: this.props.item.PEMBAYARAN_KONSULTASI == 2 ? null : 'none' }}>

                      <div className="col-8">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                            marginLeft: 60
                          }}
                        >
                          Diskon {this.props.item.PEMBAYARAN_DISKON + "%"}
                        </label>
                      </div>
                      <div className="col-4">
                        <table>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 100 }} colSpan={2} align="right">
                              <p></p>
                            </td>
                            <td style={{ width: 200 }} colSpan={2} align="right">
                              <label
                                style={{
                                  fontSize: 24,
                                  fontWeight: "500",
                                  // textDecoration: 'underline',
                                  // textUnderlineOffset: '8px'
                                }}
                              >
                                {"-" + numberFormat(_diskon).replace("Rp", "")}
                              </label>
                              {/* <p style={{ marginBottom: 0 }}>
                                {this.props.item.PEMBAYARAN_KONSULTASI == 2 ? "(Diskon " + this.props.item.PEMBAYARAN_DISKON + "%)" : null}
                              </p> */}
                            </td>
                          </tr>


                        </table>

                        <hr style={{ border: "0.5px solid #707070", margin: 4 }} />


                      </div>
                    </div>

                    <div className="row">
                      <div className="col-8">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                            marginLeft: 60,
                            // color: 'rgb(15, 71, 62)',
                            fontWeight: 'bold',
                          }}
                        >
                          Total Biaya
                        </label>
                        <p style={{ marginLeft: 60 }}>Total Amount</p>
                      </div>
                      <div className="col-4">
                        <table>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 100 }} colSpan={2} align="right">
                              <p style={{
                                // color: 'rgb(15, 71, 62)',
                                fontWeight: 'bold',
                              }}>Rp.
                              </p>
                            </td>
                            <td style={{ width: 200 }} colSpan={2} align="right">
                              <label
                                style={{
                                  fontSize: 24,
                                  // color: 'rgb(15, 71, 62)',
                                  fontWeight: 'bold',
                                }}
                              >
                                {this.props.item.NAMA_KONSULTASI ? numberFormat(this.props.item.TOTAL_HARGA).replace("Rp", "") : ""}
                              </label>
                            </td>
                          </tr>

                        </table>

                      </div>
                    </div>

                  </form>
                  <hr style={{ border: "0.5px solid #707070", marginTop: 0 }} />


                  <form
                    style={{
                      padding: "0px 20px 0px 20px",
                      fontFamily: "Montserrat",
                      // marginTop: "24px",
                    }}
                  >


                    <div className="row">
                      <div className="col-6">
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                            textDecoration: 'underline',
                            textUnderlineOffset: '4px'
                          }}
                        >
                          METODE PEMBAYARAN :
                        </label>
                        <p>Payment Method:</p>
                      </div>
                      <div className="col-6">
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6" style={{
                        // float: 'right', 
                        // border: '1px solid black'
                      }}>
                        <label
                          style={{
                            lineHeight: 0,
                            fontSize: 24,
                            textAlign: "left",
                            marginLeft: 60,
                            marginTop: 24
                          }}
                        >
                          {this.props.item.NAMA_KONSULTASI ? this.props.item.METODE_PEMBAYARAN : ""}
                        </label>
                      </div>




                      {/* <div className="col-6">
                        <table style={{ float: 'right' }}>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 140 }}>
                              <p>
                                Rp.
                              </p>
                            </td>
                            <td>
                              <label
                                style={{
                                  fontSize: 24,
                                }}
                              >
                                {this.props.item.NAMA_KONSULTASI ? numberFormat(this.props.item.TOTAL_HARGA).replace("Rp", "") : ""}
                              </label>
                            </td>
                          </tr>
                        </table>
                      </div> */}


                      <div className="col-6">
                        <table style={{
                          // float: 'right', 
                          // border: '1px solid black',
                          width: '100%'
                        }}>
                          <tr>
                            <td style={{
                              verticalAlign: 'top',
                              fontSize: 24,
                              // width: 100
                            }}
                            // colSpan={2} 
                            // align="right"
                            >
                              <p style={{
                                // color: 'rgb(15, 71, 62)',
                                fontWeight: 'bold',
                                marginLeft: 230,
                              }}>Rp.
                              </p>
                            </td>
                            <td
                            // style={{ width: 200 }}
                            // colSpan={2}
                            // align="right"
                            >
                              <label
                                style={{
                                  fontSize: 24,
                                  // color: 'rgb(15, 71, 62)',
                                  fontWeight: 'bold',
                                  marginLeft: 77,
                                }}
                              >
                                {this.props.item.NAMA_KONSULTASI ? numberFormat(this.props.item.TOTAL_HARGA).replace("Rp", "") : ""}
                              </label>
                            </td>
                          </tr>

                        </table>

                      </div>


                    </div>
                  </form>





                  <div
                    className="footer fixed-bottom col-lg-12 col-sm-12 ml-auto"
                    style={{ paddingLeft: "40px", display: this.props.item.statusSelesai == "PERIKSA LAB" ? null : 'none' }}
                  >

                    <p
                      style={{
                        // color: 'rgb(15, 71, 62)',
                        fontWeight: "bold",
                        marginBottom: "4px",
                        // fontFamily: "var(--font-family-raleway-bold)",
                        fontSize: "18px",
                      }}
                    >
                      Dengan membawa lembar kuitansi ini, Anda mendapatkan fasilitas konsultasi hasil laboratorium dengan ketentuan:
                    </p>


                    <ul
                      style={{
                        listStyleType: "number",
                        lineHeight: "26px",
                        padding: "0px 0px 0px 12px",
                        // fontFamily: "var(--font-family-raleway-medium)",
                        fontSize: "18px",
                        fontStyle: 'italic',
                        // 
                      }}
                    >
                      <li>
                        Pemeriksaan dilakukan di laboratorium Bio Medika
                      </li>
                      <li>
                        Dokter konsultasi dan dokter perujuk laboratorium sesuai dengan yang tertera pada lembar kuitansi
                      </li>
                      
                      {this.props.item.branch_code == 'H' ?
                      (
                      <li>
                        Konsultasi hanya berlaku 1 kali, maksimal 3 hari setelah hasil laboratorium selesai
                      </li>
                      ) :
                      
                      ( 
                      <li>
                        Konsultasi hanya berlaku 1 kali, maksimal 5 hari setelah hasil laboratorium selesai
                      </li>
                      )}
                      
                    </ul>


                    {/* <p
                      style={{
                        listStyleType: "number",
                        lineHeight: "26px",
                        padding: "0px 0px 0px 12px",
                        // fontFamily: "var(--font-family-raleway-medium)",
                        fontSize: "18px",
                        fontStyle: 'italic'
                      }}
                    >
                      Dengan membawa bukti pembayaran ini, Anda mendapatkan free 1 kali biaya konsultasi hasil laboratorium yang dilakukan di laboratorium Bio Medika cabang {this.props.item.branch_name}. Maksimal 7 hari setelah hasil selesai.
                    </p> */}
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}